// extracted by mini-css-extract-plugin
export default {"right":"nav-download_right__a-Ctx","recent":"nav-download_recent__RY1kw"};